<div class="walls-list-page flex-col gap-16 h-100 min-h-0">
  @if (!loaded() && loading()) {
    <div class="w-100 h-100">
      <ui-preloader></ui-preloader>
    </div>
  } @else if (error()) {
    <ui-no-data
      [imgSrc]="noResults.imgSrc"
      [title]="noResults.title | translate"
    ></ui-no-data>
  } @else if (walls().length === 0 && !hasActiveFilters()) {
    <ui-no-data
      [imgSrc]="noData.imgSrc"
      [title]="noData.title | translate"
    ></ui-no-data>
  } @else {
    <div class="filters-row gap-8">
      <div class="filter-search">
        <ui-search
          [placeholder]="'WALLS_LIST.SEARCH_PLACEHOLDER' | translate"
          [heightPx]="32"
          [ngModel]="searchQuery()"
          (ngModelChange)="onSearchQueryChange($event)"
        ></ui-search>
      </div>

      <div class="filter-select min-w-0">
        <mat-select
          class="ui-selector w-100 min-w-0"
          panelClass="walls-filter-panel"
          [placeholder]="'WALLS_LIST.FILTERS.ALL_ORGANIZATIONS' | translate"
          [ngModel]="selectedOrganization()"
          (ngModelChange)="onOrganizationFilterChange($event)"
        >
          <mat-select-trigger>
            <span class="filter-select-text min-w-0" uiTruncateText>
              @if (selectedOrganization() === null) {
                {{ 'WALLS_LIST.FILTERS.ALL_ORGANIZATIONS' | translate }}
              } @else {
                {{ selectedOrganizationName() }}
              }
            </span>
          </mat-select-trigger>
          <mat-option [value]="null">
            <span class="filter-option-text min-w-0" uiTruncateText>
              {{ 'WALLS_LIST.FILTERS.ALL_ORGANIZATIONS' | translate }}
            </span>
          </mat-option>
          @for (organization of organizationOptions(); track organization.id) {
            <mat-option [value]="organization.id">
              <span class="filter-option-text min-w-0" uiTruncateText>{{
                organization.name
              }}</span>
            </mat-option>
          }
        </mat-select>
      </div>
    </div>

    <ng-template #typeCell let-row>
      <div>
        @if (row.isPrivate) {
          <mat-icon
            svgIcon="lock"
            class="ui-mat-icon-16"
            [matTooltip]="'COMMON.PRIVATE' | translate"
          ></mat-icon>
        } @else {
          <mat-icon
            svgIcon="public"
            class="ui-mat-icon-16"
            [matTooltip]="'COMMON.PUBLIC' | translate"
          ></mat-icon>
        }
      </div>
    </ng-template>

    <div class="table-wrapper flex-col w-100 h-100 min-h-0">
      @if (loading() && walls().length === 0) {
        <div class="w-100 h-100">
          <ui-preloader></ui-preloader>
        </div>
      } @else if (walls().length === 0) {
        <ui-no-data
          [imgSrc]="noResults.imgSrc"
          [title]="noResults.title | translate"
        ></ui-no-data>
      } @else if (tableConfig()) {
        <ui-dataset-table
          class="walls-table w-100 h-100 min-h-0"
          [data]="walls()"
          [config]="tableConfig()!"
          (loadMore)="onLoadMore()"
        ></ui-dataset-table>
      }
    </div>
  }
</div>
